export default __webpack_public_path__ + "static/media/agriculture_insurance4.13b88bdc.jpg";